import { QUESTIONS as QUESTIONS_CISSP } from './CISSP/questions'
import { QUESTIONS as QUESTIONS_CCSP } from './CCSP/questions'
import { QUESTIONS as QUESTIONS_SSCP } from './SSCP/questions'
import { QUESTIONS as QUESTIONS_CC } from './CC/questions'

import { FLASHCARDS as FLASHCARDS_CISSP } from './CISSP/flashcards'
import { FLASHCARDS as FLASHCARDS_CCSP } from './CCSP/flashcards'
import { FLASHCARDS as FLASHCARDS_SSCP } from './SSCP/flashcards'
import { FLASHCARDS as FLASHCARDS_CC } from './CC/flashcards'

// Articles are the largest content set and are only needed on the Articles screen /
// RelatedStudyArticles — never on first paint. They load lazily via dynamic import()
// (one webpack chunk per cert) to keep them out of the initial bundle. See LOAD_ARTICLES.
import { GLOSSARY as GLOSSARY_CISSP } from './CISSP/glossary'
import { GLOSSARY as GLOSSARY_CCSP } from './CCSP/glossary'
import { GLOSSARY as GLOSSARY_SSCP } from './SSCP/glossary'
import { GLOSSARY as GLOSSARY_CC } from './CC/glossary'

import { ACRONYMS as ACRONYMS_CISSP } from './CISSP/acronyms'
import { ACRONYMS as ACRONYMS_CCSP } from './CCSP/acronyms'
import { ACRONYMS as ACRONYMS_SSCP } from './SSCP/acronyms'
import { ACRONYMS as ACRONYMS_CC } from './CC/acronyms'

export const BUNDLE_QUESTIONS = {
  'cissp': QUESTIONS_CISSP,
  'ccsp': QUESTIONS_CCSP,
  'sscp': QUESTIONS_SSCP,
  'cc': QUESTIONS_CC
}

export const BUNDLE_FLASHCARDS = {
  'cissp': FLASHCARDS_CISSP,
  'ccsp': FLASHCARDS_CCSP,
  'sscp': FLASHCARDS_SSCP,
  'cc': FLASHCARDS_CC
}

// Per-cert lazy article loaders — each import() is its own webpack chunk, fetched only
// when articles are actually needed. Consumed via the shared GET_ARTICLES (async).
const ARTICLE_LOADERS = {
  'cissp': () => import('./CISSP/articles'),
  'ccsp': () => import('./CCSP/articles'),
  'sscp': () => import('./SSCP/articles'),
  'cc': () => import('./CC/articles'),
}

export const LOAD_ARTICLES = async (cert) => {
  const loader = ARTICLE_LOADERS[cert]
  if (!loader) return []
  const mod = await loader()
  return mod?.ARTICLES ?? []
}

// Static article counts so sidebar/home/exam stats stay instant without loading the
// (large) article bodies. These literals are guarded by `npm run verify:article-counts`
// (also chained into `npm run build`), which recomputes them from the articles.js files
// and fails on mismatch — so a content update can't silently desync the displayed counts.
export const BUNDLE_ARTICLE_COUNTS = {
  'cissp': 1080,
  'ccsp': 732,
  'sscp': 770,
  'cc': 100
}

export const BUNDLE_GLOSSARY = {
  'cissp': GLOSSARY_CISSP,
  'ccsp': GLOSSARY_CCSP,
  'sscp': GLOSSARY_SSCP,
  'cc': GLOSSARY_CC
}

export const BUNDLE_ACRONYMS = {
  'cissp': ACRONYMS_CISSP,
  'ccsp': ACRONYMS_CCSP,
  'sscp': ACRONYMS_SSCP,
  'cc': ACRONYMS_CC
}
